import styled from 'styled-components';
import colorTheme from '../../../../constant/colors';
import BillingSummaryCards from './BillingSummaryCards';
import ExtendSettingsForm from './ExtendSettingsForm';
import useGetPackageSms from '../services/hooks/useGetPackageSms';
import { useParams } from 'react-router-dom';

const ExtendSettingsPanel = () => {
  const { shopId } = useParams();
  const { data } = useGetPackageSms(shopId || '');
  
  return (
    <Container>
      <ExtendSettingsForm data={data} />
      <BillingSummaryCards data={data} />
    </Container>
  );
};

export default ExtendSettingsPanel;

const Container = styled.div`
  width: 30%;
  padding: 12px;
  background: ${colorTheme.fill_1};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
